<section class="point-create mt-4">
  <i-title [text]="getTitleText() | translate" [buttons]="buttons"></i-title>
  <div class="alert alert-warning mt-4" *ngIf="statut === 'update' && isLocked && writeLock.currentUser">
    <span>{{'info.pointLockedNow' | translate }}</span>
  </div>



  <super-tabs-xl [tabs]="itemsTabs" (activeTab)="changeTab($event)" [activeIndex]="activeTab"
    *ngIf="statut !== 'duplicate'"></super-tabs-xl>
  <div class="row pt-4 pb-4 justify-content-center scrollable" *ngIf="activeTab === 0">
    <app-infos-form [actualPoint]="actualPoint" [pointId]="pointId" [userInfos]="userInfos" [statut]="statut"
      [appliedModelePoint]="appliedModelePoint" (updateButtons)="updateButtons($event)"
      class="infos-form"></app-infos-form>
  </div>
  <div class="row pt-4 pb-4 justify-content-center scrollable" *ngIf="activeTab === 1">
    <app-content [pointId]="pointId" [activeState]="activeState" [showAllAccordion]="showAllAccordion"
      [globalElements]="globalElements" class="infos-form"></app-content>
  </div>
  <div class="row pt-4 pb-4 justify-content-center scrollable" *ngIf="activeTab === 2">
    <app-files class="w-100" [rights]="pointsRights" [files]="itemFiles" [pointId]="pointId" [point]="point"
      [createUpdatePoint]="true" (emitSuccessUpload)="getPointFiles()"></app-files>
  </div>
</section>





<p-dialog [(visible)]="openModelesPointsModal" styleClass="super-compos-modal-content" [style]="{ width: '70vw' }"
  [modal]="true" appendTo="body" [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title super-compos-modal-title">Utiliser un modèle de la bibliothèque</h5>
      <div class="d-flex">
        <super-button styleClass="blue me-3" (click)="openModelesPointsModal = false"
          [text]="'btn.close' | translate"></super-button>
      </div>
    </div>
  </p-header>
  <section>
    <div class="col-12">
      <super-table [forselection]="null" [items]="filteredModelesPoints | sort: 'serviceLabel' : 'ASC'"
        [columns]="columnsModelesPoints" id="super-table-modeles-points-display" [height]="'calc( 100vh - 300px)'"
        (onClickRow)="applyModelePoint($event)" [menu]="menuModelesPoint"
        (menuItemsRowClick)="setRowModelePoint($event)">
      </super-table>
    </div>
  </section>
</p-dialog>
<p-confirmDialog #cd appendTo="body" styleClass="super-compos-modal-content confirmModal" header="Confirmation"
  icon="pi pi-exclamation-triangle" key="create">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Non" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>